import * as angular from "angular";

export class DashboardsDialogsService {

  constructor(private $mdDialog) {
  }

  viewAgentsByFilters(filters?, totals?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/view-agents-by-filters.html').default,
      controller: function ($scope) {

        $scope.filters = filters || {};
        $scope.totals = totals;
        $scope.cancel = self.$mdDialog.cancel;

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  viewServicesByFilters(filters?, totals?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/view-services-by-filters.html').default,
      controller: function ($scope, $timeout) {

        $scope.filters = filters || {};
        $scope.totals = totals;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onViewServiceRelatedTasks = (service) => {
          $scope.viewedServiceTasks = service.taskList;
          $timeout(0).then(() => {
          });
        }

        $scope.onCloseViewedServiceTasks = () => {
          $scope.viewedServiceTasks = undefined;
          $timeout(0).then(() => {
          });
        }


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  viewAgentsRouteScoreByFilters(filters?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/view-agents-route-score-by-filters.html').default,
      controller: function ($scope) {

        $scope.filters = filters || {};

        $scope.cancel = self.$mdDialog.cancel;

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


}

angular
  .module('bringoz.admin.dashboards')
  .service('dashboardsDialogsService', DashboardsDialogsService);
